module.exports = __webpack_public_path__ + "img/logo.09c81ba6.png";